<div
  class="group/pos relative rounded-md border border-l-2 border-slate-200 bg-white transition-[border-color,box-shadow] duration-150 hover:shadow-sm [&.cdk-drop-list-dragging]:ring-2 [&.cdk-drop-list-dragging]:ring-primary/40"
  [class]="accentClass()"
  data-no-pan="true"
  data-testid="oe-position-row"
  cdkDropList
  [id]="dropListId()"
  [cdkDropListData]="position().assignees"
  [cdkDropListConnectedTo]="store.dropListIds()"
  [cdkDropListDisabled]="!position().canManage"
  (cdkDropListDropped)="onDrop($event)"
>
  <div hlmAccordion>
    <div
      hlmAccordionItem
      class="border-b-0"
      [isOpened]="expanded()"
      (openedChange)="onExpandedChange($event)"
    >
      <hlm-accordion-trigger
        triggerClass="h-[34px] w-full items-center gap-1.5 px-2 py-0 text-[13px] font-medium text-slate-800 hover:no-underline"
        data-no-pan="true"
        data-no-drag="true"
      >
        <span class="min-w-0 truncate">{{ position().name }}</span>
        <span
          class="inline-flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-primary/10 px-1 text-[10px] font-semibold text-primary"
          [title]="
            (position().assignees.length === 1
              ? 'organigram.position.personOne'
              : 'organigram.position.personOther'
            ) | transloco
          "
          >{{ position().assignees.length }}</span
        >
      </hlm-accordion-trigger>

      <!-- The Brain primitive rather than <hlm-accordion-content>: the Helm
           wrapper hard-codes pb-4, which would break the card height math. -->
      <div
        brnAccordionContent
        class="overflow-hidden transition-all data-[state=closed]:h-0 data-[state=open]:h-(--brn-accordion-content-height)"
        data-no-pan="true"
        data-no-drag="true"
      >
        <div class="pr-1 pb-1">
          <div
            class="ml-3 flex flex-col overflow-y-auto border-l border-slate-200 pl-1"
            [style.maxHeight.px]="listMaxHeight"
          >
            @for (
              assignee of position().assignees;
              track assignee.personPositionId
            ) {
              <org-person-row
                class="active:cursor-grabbing"
                [class.cursor-grab]="position().canManage"
                [person]="assignee"
                cdkDrag
                [cdkDragDisabled]="!position().canManage"
                [cdkDragData]="assignee"
                [cdkDragScale]="dragScale()"
                [canManage]="position().canManage"
              />
            } @empty {
              <p
                class="flex h-8 items-center justify-center rounded-md border border-dashed border-slate-200 text-[11px] text-slate-400"
              >
                {{ 'organigram.position.empty' | transloco }}
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--
    Over the trigger's right end, left of its chevron, and only on hover or
    focus: with them always shown the name would have no room left in 240px.
    The buttons are flex so the icon has no baseline to sit on: as blocks
    they kept room for descenders under it and the icons rode high.
  -->
  @if (hasActions()) {
    <div
      class="absolute top-px right-7 flex h-8 items-center gap-0.5 bg-white pl-1 opacity-0 transition-opacity duration-150 group-hover/pos:opacity-100 focus-within:opacity-100 has-aria-expanded:opacity-100"
      data-testid="oe-position-row-actions"
    >
      @if (position().canManage) {
        <button
          type="button"
          class="flex items-center rounded-md p-0.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
          [title]="
            ('organigram.node.viewPermissions' | transloco) +
            ' · ' +
            position().roleCount +
            ' ' +
            ((position().roleCount === 1
              ? 'organigram.position.roleOne'
              : 'organigram.position.roleOther'
            ) | transloco)
          "
          data-no-pan="true"
          data-no-drag="true"
          (click)="onViewPermissions($event)"
        >
          <span class="material-icons text-base">security</span>
        </button>
        <button
          type="button"
          class="flex items-center rounded-md p-0.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
          [title]="'organigram.node.addPerson' | transloco"
          data-no-pan="true"
          data-no-drag="true"
          (click)="onAddPerson($event)"
        >
          <span class="material-icons text-base">person_add</span>
        </button>
        <button
          type="button"
          class="flex items-center rounded-md p-0.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
          [title]="'organigram.node.editPosition' | transloco"
          data-no-pan="true"
          data-no-drag="true"
          (click)="onEdit($event)"
        >
          <span class="material-icons text-base">edit</span>
        </button>
      }
      @if (hasMenu()) {
        <button
          type="button"
          class="flex items-center rounded-md p-0.5 text-slate-400 hover:bg-slate-100 hover:text-slate-700"
          [title]="'organigram.position.more' | transloco"
          data-no-pan="true"
          data-no-drag="true"
          [hlmDropdownMenuTrigger]="moreMenu"
          (click)="$event.stopPropagation()"
        >
          <span class="material-icons text-base">more_vert</span>
        </button>
      }
    </div>
  }
</div>

<ng-template #moreMenu>
  <hlm-dropdown-menu>
    @if (canDelete()) {
      <button hlmDropdownMenuItem (triggered)="onDelete()">
        <span class="flex w-full items-center gap-2 text-destructive">
          <span class="material-icons text-lg" aria-hidden="true">remove</span>
          {{ 'organigram.node.deletePosition' | transloco }}
        </span>
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
